import {
  loading,
  errorLoading,
  loaded,
  responseHandler,
  errorGetStatus,
  tokenInterceptor,
  errorGetText,
} from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import { fetchAppsAction } from './AppWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer
let page = 1
let maxPage = 1
let limit = 100
let isFetchingDatas = false

export const userManagementWS = (state = {
  users: [], nbUsers: -1, groups: [], copyUsers: [],
  ownerUsers: []
}, action) => {
  let users
  let idUser
  switch (action.type) {
    case Constants.ActionsConstants.USERS.FETCH_USERS:
      if (action.datas.content) {
        let users
        if (action.datas.reset) {
          users = action.datas.content
        } else {
          users = state.users.concat(action.datas.content)
        }
        return Object.assign({}, state, {
          users: users,
          nbUsers: action.datas.totalElements
        })
      } else {
        return Object.assign({}, state, { users: action.datas })
      }
    case Constants.ActionsConstants.USERS.ADD_USER_TO_STORE:
      users = JSON.parse(JSON.stringify(state.users))
      users.unshift(action.datas)
      return Object.assign({}, state, { users })
    case Constants.ActionsConstants.USERS.REMOVE_USER_FROM_STORE:
      users = JSON.parse(JSON.stringify(state.users))
      idUser = -1
      users.map((user, index) => {
        if (user.id === action.datas) idUser = index
        return null
      })
      if (idUser > -1) {
        users.splice(idUser, 1)
      }
      return Object.assign({}, state, { users })
    case Constants.ActionsConstants.USERS.MODIFY_USER_FROM_STORE:
      users = JSON.parse(JSON.stringify(state.users))
      idUser = -1
      users.map((user, index) => {
        if (user.id === action.datas.id) idUser = index
        return null
      })
      if (idUser > -1) {
        users[idUser] = action.datas
      }
      return Object.assign({}, state, { users })
    case Constants.ActionsConstants.USERS.CLEAR_USERS:
      return Object.assign({}, state, { users: action.datas, nbUsers: -1 })
    case Constants.ActionsConstants.USERS.FETCH_GW_USERS:
      return Object.assign({}, state, { copyUsers: action.datas })
    case Constants.ActionsConstants.USERS.FETCH_OWNER_USERS:
      return Object.assign({}, state, { ownerUsers: action.datas })
    case Constants.ActionsConstants.USERS.FETCH_GROUP_PAGE:
      return Object.assign({}, state, { groups: getSortedGroups(action.datas) })
    case Constants.ActionsConstants.USERS.FETCH_GROUP:
      return Object.assign({}, state, { groups: getSortedGroups(action.datas) })
    case Constants.ActionsConstants.USERS.CLEAR_GROUPS:
      return Object.assign({}, state, { groups: getSortedGroups(action.datas) })
    default:
      return state
  }
}

function getSortedGroups(data) {
  let normals = data.filter(g => (!g.type || g.type === 'GROUP')).sort((a, b) => a.label.localeCompare(b.label))
  let azureAds = data.filter(g => (g.type === 'AZURE_AD')).sort((a, b) => a.label.localeCompare(b.label))
  let specifics = data.filter(g => g.specific).sort((a, b) => a.label.localeCompare(b.label))
  let spaces = data.filter(g => g.type === 'SPACE').sort((a, b) => a.label.localeCompare(b.label))
  data = spaces.concat(specifics).concat(normals).concat(azureAds)
  return data
}

export const setUsers = (data) => {
  return {
    type: Constants.ActionsConstants.USERS.FETCH_USERS,
    datas: data,
  }
}

export const clearUsers = (data) => {
  return {
    type: Constants.ActionsConstants.USERS.CLEAR_USERS,
    datas: [],
  }
}

export const addUserToStore = (data) => {
  return {
    type: Constants.ActionsConstants.USERS.ADD_USER_TO_STORE,
    datas: data,
  }
}

export const removeUserId = (data) => {
  return {
    type: Constants.ActionsConstants.USERS.REMOVE_USER_FROM_STORE,
    datas: data,
  }
}

export const modifyUserId = (data) => {
  return {
    type: Constants.ActionsConstants.USERS.MODIFY_USER_FROM_STORE,
    datas: data,
  }
}

export const setGWUsers = (data) => {
  return {
    type: Constants.ActionsConstants.USERS.FETCH_GW_USERS,
    datas: data,
  }
}

export const setOwnerUsers = (data) => {
  return {
    type: Constants.ActionsConstants.USERS.FETCH_OWNER_USERS,
    datas: data,
  }
}

export function fetchParticipation(dispatch, appId, application, sort, dir, searchUserTxt) {
  function fetchModeParticipation() {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.DETAIL_APP + appId + '/APPLICATION_PARTICIPATION'
    return fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        fetchAppsAction(dispatch, data).setAppParticipationInStore()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveModeParticipation() {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.UPDATE_APP + 'APPLICATION_PARTICIPATION'
    dispatch(loading(''))
    return fetch(urlServer + entryPoint + method, {
      method: 'PUT',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(application),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        return fetchGroupsAction(dispatch, application.id).GetGroups().then(() => {
          return fetchUsersAction(dispatch, application.id, null,
            null, null, null, sort, dir, searchUserTxt, true).GetUsers().then(() => {
              dispatch(loaded('Error.Croutons.saveSuccess'))
              fetchAppsAction(dispatch, data).setAppParticipationInStore()
            })
            .catch(error => {
              if (errorGetStatus(error) === 401) {
                dispatch(errorLoading('Error.Croutons.authExpired'))
                fetchLogoutAction(dispatch).fetchLogout()
              } else {
                dispatch(errorLoading('Error.Croutons.internalError'))
              }
            })
        })
          .catch(error => {
            if (errorGetStatus(error) === 401) {
              dispatch(errorLoading('Error.Croutons.authExpired'))
              fetchLogoutAction(dispatch).fetchLogout()
            } else {
              dispatch(errorLoading('Error.Croutons.internalError'))
            }
          })
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.internalError'))
        }
      })
  }

  return {
    fetchModeParticipation,
    saveModeParticipation,
  }
}

export function fetchUsersAction(dispatch, appid, user, groups, file = null, locale = null, sort, dir, search,
  resetUsers) {
  function reset() {
    page = 1
    maxPage = 1
    isFetchingDatas = false
    dispatch(clearUsers())
  }

  function GetUsers() {
    if (resetUsers) {
      fetchUsersAction(dispatch).reset()
    }
    if (page <= maxPage && !isFetchingDatas) {
      isFetchingDatas = true
      let entryPoint = Constants.UrlsConstants.userWSEntryPoint
      let method = Constants.MethodsWSConstants.USER_MANAGEMENT.FETCH_USERS
      // dispatch(loading(method))

      if (page <= maxPage) {
        let url = urlServer + entryPoint + method + appid
        if (groups && groups.length) {
          url = urlServer + entryPoint + method + appid + '/' + groups[0]
        }
        url = url + '?page=' + page + '&size=' + limit
        if (sort) {
          url = url + '&sort=' + sort
        }
        if (dir) {
          url = url + '&dir=' + dir
        }
        if (search) {
          url = url + '&search=' + encodeURIComponent(search)
        }
        return fetch(url, {
          method: 'GET',
          headers: Constants.UrlsConstants.header,
        })
          .then(response => {
            tokenInterceptor(response)
            return responseHandler(response)
          })
          .then(r => r.json())
          .then(data => {
            maxPage = data.totalPages
            if (maxPage >= page) page++
            isFetchingDatas = false
            if (resetUsers) {
              data.reset = true
            }
            dispatch(setUsers(data))
          })
          .catch(error => {
            // dispatch(errorLoading(method))
            if (errorGetStatus(error) === 401) {
              dispatch(errorLoading('Error.Croutons.authExpired'))
              fetchLogoutAction(dispatch).fetchLogout()
              // window.location.href='/'
            }
          })
      }
    }
  }

  function GetSeenUsersByGroups() {
    let entryPoint = Constants.UrlsConstants.userWSEntryPoint
    let method = Constants.MethodsWSConstants.USER_MANAGEMENT.FETCH_USERS_IN_GROUPS
    fetch(urlServer + entryPoint + method + appid, {
      method: 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(groups),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setUsers(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function GetOwnerUsers() {
    let entryPoint = Constants.UrlsConstants.userFOEntryPoint
    let method = Constants.MethodsWSConstants.USER_MANAGEMENT.FETCH_USERS + 'copy?owner=true'
    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setOwnerUsers(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function GetCopyUsers() {
    let entryPoint = Constants.UrlsConstants.userFOEntryPoint
    let method = Constants.MethodsWSConstants.USER_MANAGEMENT.FETCH_USERS + 'copy'
    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setGWUsers(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function AddUser() {
    let entryPoint = Constants.UrlsConstants.userWSEntryPoint
    let method = Constants.MethodsWSConstants.USER_MANAGEMENT.ADD_USER

    // dispatch(loading(method))
    return fetch(urlServer + entryPoint + method + appid, {
      method: 'POST',
      body: JSON.stringify(user),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        // dispatch(loaded(method))
        fetchUsersAction(dispatch, appid, user, groups, file, locale, sort, dir, search, reset).GetUsers()
        dispatch(loaded('Error.Croutons.saveSuccess'))
        return data
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 409) {
          dispatch(errorLoading('Error.Croutons.userWSAlreadyExists'))
        } else if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function ModifyUser() {
    let entryPoint = Constants.UrlsConstants.userWSEntryPoint
    let method = Constants.MethodsWSConstants.USER_MANAGEMENT.MODIFY_USER + appid
    // dispatch(loading(method))
    return fetch(urlServer + entryPoint + method, {
      method: 'PUT',
      body: JSON.stringify(user),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchUsersAction(dispatch, appid, user, groups, file, locale, sort, dir, search, reset).GetUsers()
        return data
      })
      .catch(error => {
        if (errorGetStatus(error) === 409) {
          dispatch(errorLoading('Error.Croutons.userWSAlreadyExists'))
        } else if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function DeleteUser() {
    if (user.id) {
      let entryPoint = Constants.UrlsConstants.userWSEntryPoint
      let method = Constants.MethodsWSConstants.USER_MANAGEMENT.DELETE_USER + appid + '/'
      // dispatch(loading(method))
      fetch(urlServer + entryPoint + method + user.id, {
        method: 'DELETE',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(data => {
          dispatch(loaded('Error.Croutons.deleteSuccess'))
          fetchUsersAction(dispatch, appid, user, groups, file, locale, sort, dir, search, reset).GetUsers()
        })
        .catch(error => {
          // dispatch(errorLoading(method))
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
            // window.location.href='/'
          } else {
            dispatch(errorLoading('Error.Croutons.deleteError'))
          }
        })
    }
  }

  function ImportLDAPUsers() {
    let entryPoint = Constants.UrlsConstants.userWSEntryPoint
    let method = Constants.MethodsWSConstants.USER_MANAGEMENT.IMPORT_LDAP_USERS
    fetch(urlServer + entryPoint + method + appid, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        reset()
        fetchGroupsAction(dispatch, appid).GetGroups()
        GetUsers()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function uploadUsers() {
    if (file && appid && locale) {
      let entryPoint = Constants.UrlsConstants.userWSEntryPoint
      let method = Constants.MethodsWSConstants.USER_MANAGEMENT.ADD_USER + 'csv/' + appid
      let formData = new FormData()
      formData.append('file', file)
      formData.append('locale', locale)
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      }
      fetch(urlServer + entryPoint + method, {
        method: 'POST',
        body: formData,
        headers,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          if (data.error) {
            dispatch(errorLoading(data.error))
          } else {
            dispatch(loaded('Error.Croutons.uploadSuccess'))
          }
          reset()
          fetchGroupsAction(dispatch, appid).GetGroups()
          GetUsers()
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.uploadFail'))
          }
        })
    }
  }

  return {
    reset,
    GetUsers,
    GetSeenUsersByGroups,
    GetOwnerUsers,
    GetCopyUsers,
    AddUser,
    ModifyUser,
    DeleteUser,
    ImportLDAPUsers,
    uploadUsers,
  }
}

export const setGroups = (data) => {
  return {
    type: Constants.ActionsConstants.USERS.FETCH_GROUP,
    datas: data,
  }
}

export const setGroupPage = (data) => {
  return {
    type: Constants.ActionsConstants.USERS.FETCH_GROUP_PAGE,
    datas: data,
  }
}

export const clearGroups = (data) => {
  return {
    type: Constants.ActionsConstants.USERS.CLEAR_GROUPS,
    datas: [],
  }
}

export function fetchGroupsAction(dispatch, appid, group, azureConfig, input) {
  function Reset() {
    dispatch(clearGroups())
  }

  function GetAzureADGroups() {
    if (!input) {
      return Promise.resolve({ options: [] })
    }
    let entryPoint = Constants.UrlsConstants.groupEntryPoint
    let method = Constants.MethodsWSConstants.USER_MANAGEMENT.FETCH_AZURE_GROUPS
    return fetch(urlServer + entryPoint + method + appid + '?search=' + input, {
      method: 'POST',
      body: JSON.stringify(azureConfig),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        return { options: data }
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }

  function GetGroups() {
    let entryPoint = Constants.UrlsConstants.groupEntryPoint
    let method = Constants.MethodsWSConstants.USER_MANAGEMENT.FETCH_GROUP
    return fetch(urlServer + entryPoint + method + appid + '?sort=label', {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setGroupPage(data))
        return data
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }

  function GetAllGroups() {
    let entryPoint = Constants.UrlsConstants.groupEntryPoint
    let method = Constants.MethodsWSConstants.USER_MANAGEMENT.FETCH_GROUP
    // dispatch(loading(method))
    fetch(urlServer + entryPoint + method + appid + '?sort=label', {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setGroups(data))
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }

  function AddGroup() {
    let entryPoint = Constants.UrlsConstants.groupEntryPoint
    let method = Constants.MethodsWSConstants.USER_MANAGEMENT.ADD_GROUP
    // dispatch(loading(method))
    return fetch(urlServer + entryPoint + method + appid, {
      method: 'POST',
      body: JSON.stringify(group),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        // dispatch(loaded(method))
        dispatch(loaded('Error.Croutons.saveSuccess'))
        return GetGroups().then(groups => {
          dispatch(clearUsers())
          let index = getSortedGroups(groups).findIndex(g => g.id === data.id)
          // getSortedGroups(groups).map((currentGroup, currentIndex) => {
          //   if (currentGroup.id === data.id) {
          //     index = currentIndex
          //   }
          //   return null
          // })
          return index
        })
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 409) {
          dispatch(errorLoading('Error.Croutons.groupAlreadyExists'))
        } else if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
        return -1
      })
  }

  function ModifyGroup() {
    let entryPoint = Constants.UrlsConstants.groupEntryPoint
    let method = Constants.MethodsWSConstants.USER_MANAGEMENT.MODIFY_GROUP + appid

    // dispatch(loading(method))
    return fetch(urlServer + entryPoint + method, {
      method: 'PUT',
      body: JSON.stringify(group),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        // dispatch(loaded(method))
        dispatch(loaded('Error.Croutons.saveSuccess'))
        return GetGroups().then(groups => {
          let index = groups.findIndex(g => g.id === data.id)
          // groups.map((currentGroup, currentIndex) => {
          //   if (currentGroup.id === data.id) {
          //     index = currentIndex
          //     return
          //   }
          // })
          return index
        })
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 409) {
          dispatch(errorLoading('Error.Croutons.groupAlreadyExists'))
        } else if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function DeleteGroup() {
    if (group.id) {
      let entryPoint = Constants.UrlsConstants.groupEntryPoint
      let method = Constants.MethodsWSConstants.USER_MANAGEMENT.DELETE_GROUP + appid + '/'
      // dispatch(loading(method))
      return fetch(urlServer + entryPoint + method + group.id, {
        method: 'DELETE',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(data => {
          // dispatch(loaded(method))
          dispatch(loaded('Error.Croutons.deleteSuccess'))
          return GetGroups()
        })
        .catch(error => {
          let code = errorGetStatus(error)
          let text = errorGetText(error)
          if (code === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
            // window.location.href='/'
          } else if (code === 403 && text === 'USED_AS_PARENT') {
            dispatch(errorLoading('Error.Croutons.deleteUsedGroup'))
          } else {
            dispatch(errorLoading('Error.Croutons.deleteError'))
          }
        })
    }
  }
  return {
    Reset,
    GetAzureADGroups,
    GetGroups,
    GetAllGroups,
    AddGroup,
    ModifyGroup,
    DeleteGroup,
  }
}
